import { render } from "./500.vue?vue&type=template&id=6b6e63a2"
import script from "./500.vue?vue&type=script&lang=ts"
export * from "./500.vue?vue&type=script&lang=ts"
script.render = render

export default script